/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignPlanAssetsRequestDto
 */
export interface AssignPlanAssetsRequestDto {
    /**
     * All assets to (re)assign to this plan
     * @type {Array<string>}
     * @memberof AssignPlanAssetsRequestDto
     */
    assetIds: Array<string>;
    /**
     * Subset of assetIds confirmed by the user to replace their prior active plan
     * @type {Array<string>}
     * @memberof AssignPlanAssetsRequestDto
     */
    replaceAssetIds?: Array<string>;
    /**
     * Assignment start date, defaults to now
     * @type {Date}
     * @memberof AssignPlanAssetsRequestDto
     */
    startDate?: Date;
}

/**
 * Check if a given object implements the AssignPlanAssetsRequestDto interface.
 */
export function instanceOfAssignPlanAssetsRequestDto(value: object): value is AssignPlanAssetsRequestDto {
    if (!('assetIds' in value) || value['assetIds'] === undefined) return false;
    return true;
}

export function AssignPlanAssetsRequestDtoFromJSON(json: any): AssignPlanAssetsRequestDto {
    return AssignPlanAssetsRequestDtoFromJSONTyped(json, false);
}

export function AssignPlanAssetsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignPlanAssetsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetIds': json['assetIds'],
        'replaceAssetIds': json['replaceAssetIds'] == null ? undefined : json['replaceAssetIds'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
    };
}

export function AssignPlanAssetsRequestDtoToJSON(json: any): AssignPlanAssetsRequestDto {
    return AssignPlanAssetsRequestDtoToJSONTyped(json, false);
}

export function AssignPlanAssetsRequestDtoToJSONTyped(value?: AssignPlanAssetsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetIds': value['assetIds'],
        'replaceAssetIds': value['replaceAssetIds'],
        'startDate': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString(),
    };
}

